module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAAVhJREFUKFN9kj9LA0EQxd+7xIAWYhs7sVQQYuOfSrAVGytT2GiOiFfYWZ4fQJugcGdsBLGzEb9BJFqonZ1Y6ZaCjRCz+2TDBkSiU+yyb+c3j9lZIkSWZUMANiVVSU6RhKQnkueSTuI4/vKp9EuWZWUAVwBm+wV+7Q+dTmclSZI3hsrtf5L77IMxZt4DdQDHQU0BTADY6NmTZ865Z5L74X6HeZ63JC16wVo7WSwWZyRdBmDNWnsfRdFLANre4R3AmBckfQIYIlkM5y6AL5LDAfjwDu+SxkheOOdOBzUdRdGqpATAh3e4AbDggVqttj4IyPP8UNKupFvvsC3pSFKX5FIcx62fULPZnLbW3gEYAZD0n/UWQCX0cFAoFK4lWQDLzrk9kqMAHo0xc73BNRqN8VKp5AdX+WNwj865lXq9/toDfKRpWiqXy1sAqgCmwiv1voYxJk/TtOO1b54coR7zVgsgAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/icon/set-icon.png
// module id = Z258
// module chunks = 1